import * as React from 'react';
import { groupBy } from 'lodash';
import gmcngineLogo from '../images/GMCNgine3.png';
import icmecLogo from '../images/logo-gmcn.png';
import fifaLogo from '../images/FIFA.png';
import ecaLOGO from '../images/ECA.png';
import clubs from '../data/clubs';
import './clubsList.css';

function ClubList(): React.ReactElement {
  const groupedClubs = React.useMemo(() => groupBy(clubs, 'country'), [clubs]);
  return (
    <div className="club-list">
      <div className="club-list__header">
        <div className="club-list__title">
          <h1>FOOTBALL CARES</h1>
          <h5>These are the clubs that are actively involved in this initiative.</h5>
        </div>
        <div className="club-list__brand">
          <span>POWERED BY</span>
          <img src={gmcngineLogo} alt="GMCNgine Logo" />
        </div>
      </div>
      <div className="club-list__teams">
        {Object.keys(groupedClubs).sort().map((key, i) =>
          <ul key={`${key}-${i}`} className="club-list__country">
            <h5>{key}</h5>
            {groupedClubs[key].sort((a, b) => a.name < b.name ? -1 : 1).map(c =>
              <li key={`${c.name}-${i}`} className="club-list__team">
                <img className="team-logo" src={c.logo} alt="Club logo" /> {c.name}
              </li>
            )}
          </ul>
        )}
      </div>
      <div className="club-list__footer">
        <div className="club-list__footer-section">
          <h2 className="club-list__footer-title">Our Partners</h2>
          <div className="club-list__partners">
            <img className="club-list__partner-logo" src={fifaLogo} alt="ICMEC" />
            <img className="club-list__partner-logo" src={ecaLOGO} alt="ICMEC" />
            <img className="club-list__partner-logo" src={icmecLogo} alt="ICMEC" />
          </div>
          <p className="club-list_version">Version 1.8.1</p>
        </div>
      </div>
    </div>
  )
}

export default React.memo(ClubList);


// WEBPACK FOOTER //
// ./src/modules/Dashboard/Partners/club-list/ClubList.tsx